<div class="college-ac" (focusout)="onFocusOut($event)" (keydown.escape)="close()">
  <div class="college-ac__field">
    <ng-content select="input"></ng-content>

    <!-- mousedown is cancelled so picking an option doesn't blur the input first -->
    <ul class="college-ac__panel" *ngIf="isOpen" role="listbox" (mousedown)="$event.preventDefault()">
      <li class="college-ac__status" *ngIf="isSearching">Searching colleges...</li>
      <li class="college-ac__status" *ngIf="!isSearching && results.length === 0">No colleges found.</li>
      <ng-container *ngIf="!isSearching">
        <li class="college-ac__option" role="option" *ngFor="let item of results; trackBy: trackById"
          (click)="select(item)">
          <div class="college-ac__name">{{ item.name }}</div>
          <div class="college-ac__meta" *ngIf="item.city || item.state">
            <span *ngIf="item.city">{{ item.city }}</span><span *ngIf="item.city && item.state">, </span><span *ngIf="item.state">{{ item.state }}</span>
          </div>
        </li>
      </ng-container>
    </ul>
  </div>

  <!-- Host's validation messages -->
  <ng-content></ng-content>

  <div class="college-ac__cant-find" *ngIf="showCantFind">
    <button type="button" (click)="onCantFind()">Can't find your college/university?</button>
  </div>
</div>
